import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04590346"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    class: "w-5 h-5 text-gray-400",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "black"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
    })
  ])
], -1))
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 font-bold text-nominee-black"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "white",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = {
  key: 0,
  class: "w-10/12 -mb-2 text-xs text-right text-nominee-danger lg:-mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListboxLabel = _resolveComponent("ListboxLabel")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w-full font-semibold",
    onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
  }, [
    _createVNode(_component_Listbox, {
      modelValue: _ctx.selectedItem,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
    }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ListboxLabel, { class: "text-sm tracking-normal text-black capitalize md:text-sm" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ListboxButton, {
            class: _normalizeClass([{
            'text-gray-900': _ctx.selectedItem.id != 0,
            'focus:border-nominee-danger border-nominee-danger ': _ctx.error,
            'focus:border-white border-gray-400 ': !_ctx.error,
            'focus:border-white border-2 border-gray-900 ': open,
          }, "relative w-full p-0 pl-3 pr-8 text-base font-light text-left text-gray-400 bg-white border border-gray-300 rounded-sm shadow sm:py-2 focus:outline-none focus:border focus:border-white h-9 md:h-10"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["block truncate", _ctx.selectedItem.id !== -1 && 'text-nominee-black'])
              }, _toDisplayString(_ctx.selectedItem.name), 3),
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["class"]),
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-100 ease-in transform ",
            "enter-from-class": "translate-y-1 opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition duration-100 ease-in transform",
            "leave-from-class": "opacity-100 ",
            "leave-to-class": "translate-y-1 opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ListboxOptions, {
                class: _normalizeClass(["absolute text-left w-full py-1 mt-1 mb-1 overflow-auto text-xs font-light bg-gray-900 border-white rounded-md shadow-xl bg-opacity-90 backdrop-filter backdrop-blur-sm lg:max-h-80 max-h-80 ring-0 focus:outline-none sm:text-sm z-50", _ctx.showOptionsAbove && 'bottom-full'])
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(_component_ListboxOption, {
                      key: item.id,
                      value: item,
                      as: "template",
                      class: "p-2 border-white border-b-1 border-opacity-20",
                      onClick: _ctx.handleInput
                    }, {
                      default: _withCtx(({ active }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([
                  active ? 'text-white bg-gray-400 bg-opacity-60' : 'text-gray-300',
                  'cursor-default select-none relative py-1 pl-10 pr-4',
                ])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([_ctx.selectedItem.id === item.id ? 'font-semibold text-white' : 'font-normal', 'block truncate'])
                          }, _toDisplayString(item.name), 3),
                          (_ctx.selectedItem.id === item.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.error && _ctx.error != ' ')
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ])
  ], 32))
}